import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { continueVideoProcessing } from "@/store/dashboardSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";

export function VideoItemControlsVideoContinueButton({ video, task, isReady }) {
  const dispatch = useDispatch();

  const [continueStatus, setContinueStatus] = useState(false);
  const callVideoContinue = async () => {
    try {
      const activeConfirm = window.confirm(
        "Are you sure you want to continue the pipeline?"
      );
      if (activeConfirm === false) return;

      setContinueStatus(true);
      await dispatch(
        continueVideoProcessing({ videoId: video.pk, currentStage: task.stage })
      );
    } finally {
      setContinueStatus(false);
    }
  };

  return (
    <Button
      key={`video-item.${video.pk}.proceed`}
      variant={isReady ? "outline-success" : "outline-dark"}
      disabled={!(isReady && !continueStatus)}
      onClick={() => callVideoContinue()}
    >
      {continueStatus ? (
        <FontAwesomeIcon icon={["fas", "spinner"]} spin />
      ) : (
        <FontAwesomeIcon icon={["fas", "play"]} />
      )}
    </Button>
  );
}
